module.exports = __webpack_public_path__ + "static/hkgrotesk-medium-91d68e7ba08b2ae5667bb48ee7930cb8.woff2";